// extracted by mini-css-extract-plugin
module.exports =  {"root":"ThC5awA4OTY9IBmQWUam","description":"YyBmA_R92roHnUNkvNcb","headerSuffix":"tsRjvD_gYpmUFUjv4UyM"};